import { gql } from '@apollo/client';

import graphqlClient from '@/backend/graphql';
import { Query } from 'types';

const GET_USER_ADDRESSES = gql`
  query GetUserAddressesQuery {
    viewer {
      addressesWithAccessorials {
        uuid
        streetAddress
        streetAddress1
        city
        state
        postalCode
        country
        useCount
        addressType
        shipmentType
        endpoint
        userSelectedAccessorials
        carrierAddedAccessorials
      }
    }
  }
`;

export default async function getAddresses() {
  const resp = await graphqlClient.query<Query>({
    query: GET_USER_ADDRESSES,
  });

  const addresses = resp?.data?.viewer?.addressesWithAccessorials;
  return addresses;
}
